import { Component } from '@angular/core';
import { BbitPlaceBookingFileUploadType } from '@bbitgmbh/bbit.utils';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { KnowHowUploadComponent } from '../../booking/know-how-upload/know-how-upload.component';

@Component({
  selector: 'app-know-how-files',
  imports: [KnowHowUploadComponent, I18nPipe],
  templateUrl: './know-how-files.component.html',
  styleUrl: './know-how-files.component.scss',
})
export class KnowHowFilesComponent {
  public BbitPlaceBookingFileUploadType = BbitPlaceBookingFileUploadType;
}
